<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import {
  PaginationRoot,
  type PaginationRootEmits,
  type PaginationRootProps,
} from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps<
  PaginationRootProps & {
    class?: HTMLAttributes["class"];
  }
>();

const emit = defineEmits<PaginationRootEmits>();

const rootProps = computed(() => {
  const { class: _cls, ...rest } = props;
  return rest;
});
</script>

<template>
  <PaginationRoot
    v-bind="rootProps"
    :class="cn('flex justify-center', props.class)"
    @update:page="emit('update:page', $event)"
  >
    <slot />
  </PaginationRoot>
</template>
